import { fetchCurrentEnterpriseBillsByIds } from '@mews-commander/legacy-entities/src/actions';
import { fetchAccountsByBillIds } from '@mews-commander/legacy-entities/src/actions/accounts';
import { getBill } from '@mews-commander/legacy-entities/src/ducks';
import { CommanderThunkAction } from '@mews-commander/types';

export const initializeChangeBillOwner =
    (billId: string): CommanderThunkAction =>
    async (dispatch, getState) => {
        await dispatch(fetchCurrentEnterpriseBillsByIds({ billIds: [billId] }));
        const bill = getBill(getState(), { id: billId });

        if (!bill) {
            throw new Error('Bill not found');
        }

        return dispatch(fetchAccountsByBillIds({ billIds: [bill.id] }));
    };
